// Color palette for reporting: https://www.figma.com/design/qje06pjGSs0kLdxXPIYTO3/BrainStorm-Product-Design-System?node-id=269-4219&t=KQVXamNGLdmuxs6j-1

export const reportingColors = {
  yellow: "#EF9E08",
  orange: "#FF9142",
  greenDark: "#58A57B",
  greenLight: "#60C794",
  red: "#F26A5E",
  blue: "#288BED",
  blueLight: "#6CC7DB",
  purple: "#7B6FB8",
  greyDark: "#232328",
  greyLight: "#686569",
  greyLighter: "#9C989E",
  neutral: "#D2BDBA",
};
